/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form, Row, Col, Input,
} from 'antd';
import { SIN_ESTUDIOS } from 'utils/constants';
import Select from '../../Select';

const CandidatosEstudios = ({
  form,
  rules,
  nivelesDeEstudios,
  abreviaturasDeCarreras,
  comprobantesDeEstudios,
  especialidadesDeEstudios,
  isBlocked,
}) => {
  const [estudios, setEstudios] = useState(false);

  const sinEstudios = (campo) => {
    if (campo === SIN_ESTUDIOS) {
      const borrar_campos = [
        'abreviatura',
        'comprobante',
        'numero_de_cedula_profesional',
        'especialidad_estudio',
      ];
      form.resetFields(borrar_campos);
      form.setFieldsValue({
        estudios_concluidos: false,
      });
      setEstudios(true);
    } else {
      setEstudios(false);
    }
  };

  useEffect(() => {
    const value = form.getFieldValue('nivel_de_estudios');
    sinEstudios(value);
  }, []);

  return (
    <Form
      layout="vertical"
      form={form}
      scrollToFirstError
      name="estudios"
    // initialValues={{ estudios_concluidos: false }}
    >
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item name="nivel_de_estudios" label="Nivel de Estudios" hasFeedback>
            <Select
              dataSource={nivelesDeEstudios}
              labelProp="nombre"
              onChange={(value) => sinEstudios(value)}
              disabled={isBlocked}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item name="abreviatura" label="Abreviatura de Carrera" hasFeedback>
            <Select
              disabled={estudios || isBlocked}
              dataSource={abreviaturasDeCarreras}
              labelProp="abreviatura"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item name="comprobante" label="Comprobante de Estudios" hasFeedback>
            <Select
              disabled={estudios || isBlocked}
              dataSource={comprobantesDeEstudios}
              labelProp="nombre"
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item name="estudios_concluidos" label="Estudios Concluidos" hasFeedback>
            <Select disabled={estudios || isBlocked} trueFalse />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="numero_de_cedula_profesional"
            label="Número de Cédula Profesional"
            hasFeedback
          // rules={rules.no_cedula_profesional}
          >
            <Input disabled={estudios || isBlocked} allowClear />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item name="especialidad_estudio" label="Especialidad de Estudios" hasFeedback>
            <Select
              disabled={estudios || isBlocked}
              dataSource={especialidadesDeEstudios}
              labelProp="nombre"
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CandidatosEstudios;
